import React from 'react';
import {
  ImageBoxFive,
  SecSubTitle,
  SecTitle,
  InfoMedia,
  List,
  Button
} from '../../components'; 

const AboutFive = ({...restProps})=> (
  <div {...restProps}>
    <div className="container">
      <div className="row flex-row-reverse">
        <div className="col-lg-6 mb-30 pb-10 pb-lg-0">
          <ImageBoxFive
            imageOne="images/about/ab-4-1.jpg"
            imageTwo="images/about/ab-4-2.jpg"
            imageThree="images/about/ab-4-3.jpg"
          />
        </div>
     <div className="col-lg-6 mb-30">
  <SecSubTitle><i className="fas fa-bring-forward" />OUR TRAINING APPROACH</SecSubTitle>
  <SecTitle className="text-capitalize h1">Empowering Minds Through Practical Learning</SecTitle>
  <InfoMedia
    className="exp-media"
    number="10"
    title="Years of Mentorship"
    info="We provide a hands-on learning environment where participants gain real-world experience, guided by industry professionals. Our approach ensures practical understanding and skill application."
  />
  <List className="list-style1">
    <List.Item><i className="far fa-check-circle" />Interactive Workshops & Sessions</List.Item>
    <List.Item><i className="far fa-check-circle" />Guidance from Industry Experts</List.Item>
    <List.Item><i className="far fa-check-circle" />Real Projects & Assessments</List.Item>
    <List.Item><i className="far fa-check-circle" />Flexible Online & Offline Options</List.Item>
    <List.Item><i className="far fa-check-circle" />Trusted by 500+ professionals</List.Item>
    <List.Item><i className="far fa-check-circle" />From finance to manufacturing.</List.Item>
    <List.Item><i className="far fa-check-circle" />Post-Training Career Support</List.Item>

  </List>
  <Button path="/training">Explore Programs<i className="far fa-arrow-right" /></Button>
</div>


      </div>
    </div>
  </div>
);

export default AboutFive;